import { buildCommonFilters, embedFilter } from '../sharedFilters'

const DATASET_KEY = 'billing_finances'

const commonFilters = buildCommonFilters(DATASET_KEY, {
  INSTALLATION: { column: 'units.description', label: 'Inmueble' },
  MUNICIPALITY: { column: 'municipalities.name', label: 'Municipio' },
  STATUS: false,
  USER: false,
  TENANT: false,
})

export default {
  key: DATASET_KEY,
  label: 'Facturación - Finanzas',
  timeColumn: 'billing_finances.created_at',
  permission: { action: 'read', subject: 'BillingFinance' },

  tables: {
    billing_finances: ["id", "date", "worked_days", "month", "year", "region", "state", "rems", "security_company", "job_description", "number_of_services", "service_days", "hours", "cost_per_shift", "total_cost_service", "type_of_guard", "work_schedule", "id_provider", "id_unit", "created_at", "updated_at"],
    billing_providers: ["id", "name", "created_at", "updated_at"],
    units: ["id", "id_router", "description", "address_1", "address_2", "exterior_number", "suburb", "number", "postal_code", "id_country", "id_region", "id_sector", "active", "route", "plate_number", "vin", "driver", "provider", "owner", "company", "vehicle", "allow_virtual_button_alarm", "reaction_patrol", "id_alarms_levels", "active_digital_output", "needs_check", "id_municipality", "time_zone", "data", "comments", "id_category", "id_seproban", "rems", "sirh", "created_at", "updated_at"],
    regions: ["id", "name", "code", "country_id", "acronym", "created_at", "updated_at"],
    sectors: ["id", "id_center", "name", "alcaldia", "provider", "created", "updated"],
    municipalities: [],
  },

  views: [
    { value: 'bar', label: 'Barras' },
    { value: 'dona', label: 'Dona' },
    { value: 'ring', label: 'Pastel' },
    { value: 'dataframe', label: 'Lista', adminOnly: true },
    { value: 'timeseries', label: 'Tendencia' },
    { value: 'json', label: 'JSON', adminOnly: true },
  ],

  defaults: {
    field: 'billing_providers.name',
  },

  // Metric selector — controls the `columns` URL param.
  // The first entry is the default (omitted from the URL since `$count` is
  // also the backend default).
  metrics: {
    label: 'Métrica',
    options: [
      { value: '$count', label: 'Conteo' },
      { value: '$sum_total_cost_service', label: 'Suma de costo total servicio' },
      { value: '$sum_cost_per_shift', label: 'Suma de costo por turno' },
      { value: '$sum_worked_days', label: 'Suma de días trabajados' },
    ],
  },

  csvConfig: {
    withTables: 'billing_finances',
    columns: 'billing_finances.worked_days,billing_finances.month,billing_finances.year,billing_finances.region,billing_finances.state,billing_finances.rems,billing_finances.security_company,billing_finances.job_description,billing_finances.number_of_services,billing_finances.service_days,billing_finances.hours,billing_finances.cost_per_shift,billing_finances.total_cost_service,billing_finances.type_of_guard,billing_finances.work_schedule',
    exceptColumns: 'billing_finances.date,billing_finances.id_provider,billing_finances.rems,billing_finances.worked_days',
    count: { limit: -1 },
    qualifiedColumns: true,
  },

  viewDefaults: {
    csv: { limit: -1 },
    dataframe: { limit: -1 },
    json: { limit: -1 },
    bar: { stack: 'group' },
    //timeseries: { trendline: true },
  },

  fields: [
    { key: 'billing_providers.name', label: 'Proveedor' },
    { key: 'billing_finances.job_description', label: 'Descripción del trabajo' },
    { key: 'billing_finances.security_company', label: 'Empresa de seguridad' },
    { key: 'billing_finances.type_of_guard', label: 'Tipo de guardia' },
    { key: 'billing_finances.work_schedule', label: 'Horario' },
    { key: 'billing_finances.worked_days', label: 'Días trabajados' },
    { key: 'billing_finances.service_days', label: 'Días de servicio' },
    { key: 'billing_finances.number_of_services', label: 'Número de servicios' },
    { key: 'billing_finances.hours', label: 'Horas' },
    { key: 'billing_finances.cost_per_shift', label: 'Costo por turno' },
    { key: 'billing_finances.total_cost_service', label: 'Costo total servicio' },
    { key: 'billing_finances.month', label: 'Mes' },
    { key: 'billing_finances.year', label: 'Año' },
    { key: 'units.description', label: 'Inmueble' },
    { key: 'billing_finances.region', label: 'Región' },
    { key: 'billing_finances.state', label: 'Estado' },
    { key: 'municipalities.name', label: 'Municipio' },
    { key: 'billing_finances.created_at', label: 'Creado el', defaultParams: { freq: '1mo' } },
  ],

  filters: [
    //...commonFilters,
    embedFilter(DATASET_KEY, 'billing_providers.name', 'Proveedor', 'group'),
    embedFilter(DATASET_KEY, 'billing_finances.job_description', 'Descripción del trabajo', 'name'),
    embedFilter(DATASET_KEY, 'billing_finances.type_of_guard', 'Tipo de guardia', 'type'),
    embedFilter(DATASET_KEY, 'billing_finances.work_schedule', 'Horario', 'work_schedule'),
    embedFilter(DATASET_KEY, 'billing_finances.region', 'Región', 'region_billing'),
    embedFilter(DATASET_KEY, 'billing_finances.state', 'Estado', 'state_billing'),
    embedFilter(DATASET_KEY, 'billing_finances.month', 'Mes', 'month'),
    embedFilter(DATASET_KEY, 'billing_finances.year', 'Año', 'year'),
    embedFilter(DATASET_KEY, 'billing_finances.rems', 'REMS', 'rems', {
      optionsOverrides: {
        by: 'billing_finances.rems,units.description',
        mapItem: item => ({
          value: item['billing_finances.rems'] || item.rems,
          label: item['billing_finances.rems'] || item.rems,
        }),
      },
    }),
    embedFilter(DATASET_KEY, 'billing_finances.security_company', 'Empresa de seguridad', 'security_company'),
    embedFilter(DATASET_KEY, 'billing_finances.id_unit', 'Inmueble', 'installation', {
      optionsOverrides: {
        by: 'units.id,units.description',
        mapItem: item => ({
          value: item['units.id'] || item.id,
          label: item['units.description'] || item.description || item.id,
        }),
      },
    }),
    //embedFilter(DATASET_KEY, 'sectors.name', 'Región', 'sector'),
    //embedFilter(DATASET_KEY, 'regions.name', 'Estado', 'region'),
  ],

  dateGrouping: {
    column: 'billing_finances.created_at',
    presets: [
      { value: '1d', label: 'Día' },
      { value: '1W', label: 'Semana' },
      { value: '1M', label: 'Mes' },
      { value: '1Y', label: 'Año' },
    ],
  },
}
